import { jsx as r } from "react/jsx-runtime";
import { createClassNameSelectors as p, getStylesFromSelectors as l } from "../../../utils/classNameSelectors.js";
import "../../../utils/sectionPreview.js";
import { forwardRef as h } from "react";
import y from "clsx";
import '../../../_assets/Col.ysDslJYi.css';const N = "_article_1pp19_16470", o = {
  "col-xxs-auto": "_col-xxs-auto_1pp19_86",
  "col-xxs-1": "_col-xxs-1_1pp19_122",
  "col-xxs-1-wide": "_col-xxs-1-wide_1pp19_156",
  "col-xxs-2": "_col-xxs-2_1pp19_208",
  "col-xxs-2-wide": "_col-xxs-2-wide_1pp19_242",
  "col-xxs-3": "_col-xxs-3_1pp19_294",
  "col-xxs-3-wide": "_col-xxs-3-wide_1pp19_328",
  "col-xxs-4": "_col-xxs-4_1pp19_380",
  "col-xxs-4-wide": "_col-xxs-4-wide_1pp19_414",
  "col-xxs-5": "_col-xxs-5_1pp19_466",
  "col-xxs-5-wide": "_col-xxs-5-wide_1pp19_500",
  "col-xxs-6": "_col-xxs-6_1pp19_552",
  "col-xxs-6-wide": "_col-xxs-6-wide_1pp19_586",
  "col-xxs-7": "_col-xxs-7_1pp19_638",
  "col-xxs-7-wide": "_col-xxs-7-wide_1pp19_672",
  "col-xxs-8": "_col-xxs-8_1pp19_724",
  "col-xxs-8-wide": "_col-xxs-8-wide_1pp19_758",
  "col-xxs-9": "_col-xxs-9_1pp19_810",
  "col-xxs-9-wide": "_col-xxs-9-wide_1pp19_844",
  "col-xxs-10": "_col-xxs-10_1pp19_896",
  "col-xxs-10-wide": "_col-xxs-10-wide_1pp19_930",
  "col-xxs-11": "_col-xxs-11_1pp19_982",
  "col-xxs-11-wide": "_col-xxs-11-wide_1pp19_1016",
  "col-xxs-12": "_col-xxs-12_1pp19_1068",
  "col-xxs-12-wide": "_col-xxs-12-wide_1pp19_1102",
  "col-xs-auto": "_col-xs-auto_1pp19_1154",
  "col-xs-1": "_col-xs-1_1pp19_1190",
  "col-xs-1-wide": "_col-xs-1-wide_1pp19_1224",
  "col-xs-2": "_col-xs-2_1pp19_1276",
  "col-xs-2-wide": "_col-xs-2-wide_1pp19_1310",
  "col-xs-3": "_col-xs-3_1pp19_1362",
  "col-xs-3-wide": "_col-xs-3-wide_1pp19_1396",
  "col-xs-4": "_col-xs-4_1pp19_1448",
  "col-xs-4-wide": "_col-xs-4-wide_1pp19_1482",
  "col-xs-5": "_col-xs-5_1pp19_1534",
  "col-xs-5-wide": "_col-xs-5-wide_1pp19_1568",
  "col-xs-6": "_col-xs-6_1pp19_1620",
  "col-xs-6-wide": "_col-xs-6-wide_1pp19_1654",
  "col-xs-7": "_col-xs-7_1pp19_1706",
  "col-xs-7-wide": "_col-xs-7-wide_1pp19_1740",
  "col-xs-8": "_col-xs-8_1pp19_1792",
  "col-xs-8-wide": "_col-xs-8-wide_1pp19_1826",
  "col-xs-9": "_col-xs-9_1pp19_1878",
  "col-xs-9-wide": "_col-xs-9-wide_1pp19_1912",
  "col-xs-10": "_col-xs-10_1pp19_1964",
  "col-xs-10-wide": "_col-xs-10-wide_1pp19_1998",
  "col-xs-11": "_col-xs-11_1pp19_2050",
  "col-xs-11-wide": "_col-xs-11-wide_1pp19_2084",
  "col-xs-12": "_col-xs-12_1pp19_2136",
  "col-xs-12-wide": "_col-xs-12-wide_1pp19_2170",
  "col-s-auto": "_col-s-auto_1pp19_2222",
  "col-s-1": "_col-s-1_1pp19_2258",
  "col-s-1-wide": "_col-s-1-wide_1pp19_2292",
  "col-s-2": "_col-s-2_1pp19_2344",
  "col-s-2-wide": "_col-s-2-wide_1pp19_2378",
  "col-s-3": "_col-s-3_1pp19_2430",
  "col-s-3-wide": "_col-s-3-wide_1pp19_2464",
  "col-s-4": "_col-s-4_1pp19_2516",
  "col-s-4-wide": "_col-s-4-wide_1pp19_2550",
  "col-s-5": "_col-s-5_1pp19_2602",
  "col-s-5-wide": "_col-s-5-wide_1pp19_2636",
  "col-s-6": "_col-s-6_1pp19_2688",
  "col-s-6-wide": "_col-s-6-wide_1pp19_2722",
  "col-s-7": "_col-s-7_1pp19_2774",
  "col-s-7-wide": "_col-s-7-wide_1pp19_2808",
  "col-s-8": "_col-s-8_1pp19_2860",
  "col-s-8-wide": "_col-s-8-wide_1pp19_2894",
  "col-s-9": "_col-s-9_1pp19_2946",
  "col-s-9-wide": "_col-s-9-wide_1pp19_2980",
  "col-s-10": "_col-s-10_1pp19_3032",
  "col-s-10-wide": "_col-s-10-wide_1pp19_3066",
  "col-s-11": "_col-s-11_1pp19_3118",
  "col-s-11-wide": "_col-s-11-wide_1pp19_3152",
  "col-s-12": "_col-s-12_1pp19_3204",
  "col-s-12-wide": "_col-s-12-wide_1pp19_3238",
  "col-ssm-auto": "_col-ssm-auto_1pp19_3290",
  "col-ssm-1": "_col-ssm-1_1pp19_3326",
  "col-ssm-1-wide": "_col-ssm-1-wide_1pp19_3360",
  "col-ssm-2": "_col-ssm-2_1pp19_3412",
  "col-ssm-2-wide": "_col-ssm-2-wide_1pp19_3446",
  "col-ssm-3": "_col-ssm-3_1pp19_3498",
  "col-ssm-3-wide": "_col-ssm-3-wide_1pp19_3532",
  "col-ssm-4": "_col-ssm-4_1pp19_3584",
  "col-ssm-4-wide": "_col-ssm-4-wide_1pp19_3618",
  "col-ssm-5": "_col-ssm-5_1pp19_3670",
  "col-ssm-5-wide": "_col-ssm-5-wide_1pp19_3704",
  "col-ssm-6": "_col-ssm-6_1pp19_3756",
  "col-ssm-6-wide": "_col-ssm-6-wide_1pp19_3790",
  "col-ssm-7": "_col-ssm-7_1pp19_3842",
  "col-ssm-7-wide": "_col-ssm-7-wide_1pp19_3876",
  "col-ssm-8": "_col-ssm-8_1pp19_3928",
  "col-ssm-8-wide": "_col-ssm-8-wide_1pp19_3962",
  "col-ssm-9": "_col-ssm-9_1pp19_4014",
  "col-ssm-9-wide": "_col-ssm-9-wide_1pp19_4048",
  "col-ssm-10": "_col-ssm-10_1pp19_4100",
  "col-ssm-10-wide": "_col-ssm-10-wide_1pp19_4134",
  "col-ssm-11": "_col-ssm-11_1pp19_4186",
  "col-ssm-11-wide": "_col-ssm-11-wide_1pp19_4220",
  "col-ssm-12": "_col-ssm-12_1pp19_4272",
  "col-ssm-12-wide": "_col-ssm-12-wide_1pp19_4306",
  "col-sm-auto": "_col-sm-auto_1pp19_4358",
  "col-sm-1": "_col-sm-1_1pp19_4394",
  "col-sm-1-wide": "_col-sm-1-wide_1pp19_4428",
  "col-sm-2": "_col-sm-2_1pp19_4480",
  "col-sm-2-wide": "_col-sm-2-wide_1pp19_4514",
  "col-sm-3": "_col-sm-3_1pp19_4566",
  "col-sm-3-wide": "_col-sm-3-wide_1pp19_4600",
  "col-sm-4": "_col-sm-4_1pp19_4652",
  "col-sm-4-wide": "_col-sm-4-wide_1pp19_4686",
  "col-sm-5": "_col-sm-5_1pp19_4738",
  "col-sm-5-wide": "_col-sm-5-wide_1pp19_4772",
  "col-sm-6": "_col-sm-6_1pp19_4824",
  "col-sm-6-wide": "_col-sm-6-wide_1pp19_4858",
  "col-sm-7": "_col-sm-7_1pp19_4910",
  "col-sm-7-wide": "_col-sm-7-wide_1pp19_4944",
  "col-sm-8": "_col-sm-8_1pp19_4996",
  "col-sm-8-wide": "_col-sm-8-wide_1pp19_5030",
  "col-sm-9": "_col-sm-9_1pp19_5082",
  "col-sm-9-wide": "_col-sm-9-wide_1pp19_5116",
  "col-sm-10": "_col-sm-10_1pp19_5168",
  "col-sm-10-wide": "_col-sm-10-wide_1pp19_5202",
  "col-sm-11": "_col-sm-11_1pp19_5254",
  "col-sm-11-wide": "_col-sm-11-wide_1pp19_5288",
  "col-sm-12": "_col-sm-12_1pp19_5340",
  "col-sm-12-wide": "_col-sm-12-wide_1pp19_5374",
  "col-m-auto": "_col-m-auto_1pp19_5426",
  "col-m-1": "_col-m-1_1pp19_5462",
  "col-m-1-wide": "_col-m-1-wide_1pp19_5496",
  "col-m-2": "_col-m-2_1pp19_5548",
  "col-m-2-wide": "_col-m-2-wide_1pp19_5582",
  "col-m-3": "_col-m-3_1pp19_5634",
  "col-m-3-wide": "_col-m-3-wide_1pp19_5668",
  "col-m-4": "_col-m-4_1pp19_5720",
  "col-m-4-wide": "_col-m-4-wide_1pp19_5754",
  "col-m-5": "_col-m-5_1pp19_5806",
  "col-m-5-wide": "_col-m-5-wide_1pp19_5840",
  "col-m-6": "_col-m-6_1pp19_5892",
  "col-m-6-wide": "_col-m-6-wide_1pp19_5926",
  "col-m-7": "_col-m-7_1pp19_5978",
  "col-m-7-wide": "_col-m-7-wide_1pp19_6012",
  "col-m-8": "_col-m-8_1pp19_6064",
  "col-m-8-wide": "_col-m-8-wide_1pp19_6098",
  "col-m-9": "_col-m-9_1pp19_6150",
  "col-m-9-wide": "_col-m-9-wide_1pp19_6184",
  "col-m-10": "_col-m-10_1pp19_6236",
  "col-m-10-wide": "_col-m-10-wide_1pp19_6270",
  "col-m-11": "_col-m-11_1pp19_6322",
  "col-m-11-wide": "_col-m-11-wide_1pp19_6356",
  "col-m-12": "_col-m-12_1pp19_6408",
  "col-m-12-wide": "_col-m-12-wide_1pp19_6442",
  "col-xm-auto": "_col-xm-auto_1pp19_6494",
  "col-xm-1": "_col-xm-1_1pp19_6530",
  "col-xm-1-wide": "_col-xm-1-wide_1pp19_6564",
  "col-xm-2": "_col-xm-2_1pp19_6616",
  "col-xm-2-wide": "_col-xm-2-wide_1pp19_6650",
  "col-xm-3": "_col-xm-3_1pp19_6702",
  "col-xm-3-wide": "_col-xm-3-wide_1pp19_6736",
  "col-xm-4": "_col-xm-4_1pp19_6788",
  "col-xm-4-wide": "_col-xm-4-wide_1pp19_6822",
  "col-xm-5": "_col-xm-5_1pp19_6874",
  "col-xm-5-wide": "_col-xm-5-wide_1pp19_6908",
  "col-xm-6": "_col-xm-6_1pp19_6960",
  "col-xm-6-wide": "_col-xm-6-wide_1pp19_6994",
  "col-xm-7": "_col-xm-7_1pp19_7046",
  "col-xm-7-wide": "_col-xm-7-wide_1pp19_7080",
  "col-xm-8": "_col-xm-8_1pp19_7132",
  "col-xm-8-wide": "_col-xm-8-wide_1pp19_7166",
  "col-xm-9": "_col-xm-9_1pp19_7218",
  "col-xm-9-wide": "_col-xm-9-wide_1pp19_7252",
  "col-xm-10": "_col-xm-10_1pp19_7304",
  "col-xm-10-wide": "_col-xm-10-wide_1pp19_7338",
  "col-xm-11": "_col-xm-11_1pp19_7390",
  "col-xm-11-wide": "_col-xm-11-wide_1pp19_7424",
  "col-xm-12": "_col-xm-12_1pp19_7476",
  "col-xm-12-wide": "_col-xm-12-wide_1pp19_7510",
  "col-l-auto": "_col-l-auto_1pp19_7562",
  "col-l-1": "_col-l-1_1pp19_7598",
  "col-l-1-wide": "_col-l-1-wide_1pp19_7632",
  "col-l-2": "_col-l-2_1pp19_7684",
  "col-l-2-wide": "_col-l-2-wide_1pp19_7718",
  "col-l-3": "_col-l-3_1pp19_7770",
  "col-l-3-wide": "_col-l-3-wide_1pp19_7804",
  "col-l-4": "_col-l-4_1pp19_7856",
  "col-l-4-wide": "_col-l-4-wide_1pp19_7890",
  "col-l-5": "_col-l-5_1pp19_7942",
  "col-l-5-wide": "_col-l-5-wide_1pp19_7976",
  "col-l-6": "_col-l-6_1pp19_8028",
  "col-l-6-wide": "_col-l-6-wide_1pp19_8062",
  "col-l-7": "_col-l-7_1pp19_8114",
  "col-l-7-wide": "_col-l-7-wide_1pp19_8148",
  "col-l-8": "_col-l-8_1pp19_8200",
  "col-l-8-wide": "_col-l-8-wide_1pp19_8234",
  "col-l-9": "_col-l-9_1pp19_8286",
  "col-l-9-wide": "_col-l-9-wide_1pp19_8320",
  "col-l-10": "_col-l-10_1pp19_8372",
  "col-l-10-wide": "_col-l-10-wide_1pp19_8406",
  "col-l-11": "_col-l-11_1pp19_8458",
  "col-l-11-wide": "_col-l-11-wide_1pp19_8492",
  "col-l-12": "_col-l-12_1pp19_8544",
  "col-l-12-wide": "_col-l-12-wide_1pp19_8578",
  "col-xl-auto": "_col-xl-auto_1pp19_8630",
  "col-xl-1": "_col-xl-1_1pp19_8666",
  "col-xl-1-wide": "_col-xl-1-wide_1pp19_8700",
  "col-xl-2": "_col-xl-2_1pp19_8752",
  "col-xl-2-wide": "_col-xl-2-wide_1pp19_8786",
  "col-xl-3": "_col-xl-3_1pp19_8838",
  "col-xl-3-wide": "_col-xl-3-wide_1pp19_8872",
  "col-xl-4": "_col-xl-4_1pp19_8924",
  "col-xl-4-wide": "_col-xl-4-wide_1pp19_8958",
  "col-xl-5": "_col-xl-5_1pp19_9010",
  "col-xl-5-wide": "_col-xl-5-wide_1pp19_9044",
  "col-xl-6": "_col-xl-6_1pp19_9096",
  "col-xl-6-wide": "_col-xl-6-wide_1pp19_9130",
  "col-xl-7": "_col-xl-7_1pp19_9182",
  "col-xl-7-wide": "_col-xl-7-wide_1pp19_9216",
  "col-xl-8": "_col-xl-8_1pp19_9268",
  "col-xl-8-wide": "_col-xl-8-wide_1pp19_9302",
  "col-xl-9": "_col-xl-9_1pp19_9354",
  "col-xl-9-wide": "_col-xl-9-wide_1pp19_9388",
  "col-xl-10": "_col-xl-10_1pp19_9440",
  "col-xl-10-wide": "_col-xl-10-wide_1pp19_9474",
  "col-xl-11": "_col-xl-11_1pp19_9526",
  "col-xl-11-wide": "_col-xl-11-wide_1pp19_9560",
  "col-xl-12": "_col-xl-12_1pp19_9612",
  "col-xl-12-wide": "_col-xl-12-wide_1pp19_9646",
  "col-xxl-auto": "_col-xxl-auto_1pp19_9698",
  "col-xxl-1": "_col-xxl-1_1pp19_9734",
  "col-xxl-1-wide": "_col-xxl-1-wide_1pp19_9768",
  "col-xxl-2": "_col-xxl-2_1pp19_9820",
  "col-xxl-2-wide": "_col-xxl-2-wide_1pp19_9854",
  "col-xxl-3": "_col-xxl-3_1pp19_9906",
  "col-xxl-3-wide": "_col-xxl-3-wide_1pp19_9940",
  "col-xxl-4": "_col-xxl-4_1pp19_9992",
  "col-xxl-4-wide": "_col-xxl-4-wide_1pp19_10026",
  "col-xxl-5": "_col-xxl-5_1pp19_10078",
  "col-xxl-5-wide": "_col-xxl-5-wide_1pp19_10112",
  "col-xxl-6": "_col-xxl-6_1pp19_10164",
  "col-xxl-6-wide": "_col-xxl-6-wide_1pp19_10198",
  "col-xxl-7": "_col-xxl-7_1pp19_10250",
  "col-xxl-7-wide": "_col-xxl-7-wide_1pp19_10284",
  "col-xxl-8": "_col-xxl-8_1pp19_10336",
  "col-xxl-8-wide": "_col-xxl-8-wide_1pp19_10370",
  "col-xxl-9": "_col-xxl-9_1pp19_10422",
  "col-xxl-9-wide": "_col-xxl-9-wide_1pp19_10456",
  "col-xxl-10": "_col-xxl-10_1pp19_10508",
  "col-xxl-10-wide": "_col-xxl-10-wide_1pp19_10542",
  "col-xxl-11": "_col-xxl-11_1pp19_10594",
  "col-xxl-11-wide": "_col-xxl-11-wide_1pp19_10628",
  "col-xxl-12": "_col-xxl-12_1pp19_10680",
  "col-xxl-12-wide": "_col-xxl-12-wide_1pp19_10714",
  "col-ng-xxs-auto": "_col-ng-xxs-auto_1pp19_10767",
  "col-ng-xxs-1": "_col-ng-xxs-1_1pp19_10779",
  "col-ng-xxs-2": "_col-ng-xxs-2_1pp19_10789",
  "col-ng-xxs-3": "_col-ng-xxs-3_1pp19_10799",
  "col-ng-xxs-4": "_col-ng-xxs-4_1pp19_10809",
  "col-ng-xxs-5": "_col-ng-xxs-5_1pp19_10819",
  "col-ng-xxs-6": "_col-ng-xxs-6_1pp19_10829",
  "col-ng-xxs-7": "_col-ng-xxs-7_1pp19_10839",
  "col-ng-xxs-8": "_col-ng-xxs-8_1pp19_10849",
  "col-ng-xxs-9": "_col-ng-xxs-9_1pp19_10859",
  "col-ng-xxs-10": "_col-ng-xxs-10_1pp19_10869",
  "col-ng-xxs-11": "_col-ng-xxs-11_1pp19_10879",
  "col-ng-xxs-12": "_col-ng-xxs-12_1pp19_10889",
  "col-ng-xxs-1-wide": "_col-ng-xxs-1-wide_1pp19_10899",
  "col-ng-xxs-2-wide": "_col-ng-xxs-2-wide_1pp19_10927",
  "col-ng-xxs-3-wide": "_col-ng-xxs-3-wide_1pp19_10955",
  "col-ng-xxs-4-wide": "_col-ng-xxs-4-wide_1pp19_10983",
  "col-ng-xxs-5-wide": "_col-ng-xxs-5-wide_1pp19_11011",
  "col-ng-xxs-6-wide": "_col-ng-xxs-6-wide_1pp19_11039",
  "col-ng-xxs-7-wide": "_col-ng-xxs-7-wide_1pp19_11067",
  "col-ng-xxs-8-wide": "_col-ng-xxs-8-wide_1pp19_11095",
  "col-ng-xxs-9-wide": "_col-ng-xxs-9-wide_1pp19_11123",
  "col-ng-xxs-10-wide": "_col-ng-xxs-10-wide_1pp19_11151",
  "col-ng-xxs-11-wide": "_col-ng-xxs-11-wide_1pp19_11179",
  "col-ng-xxs-12-wide": "_col-ng-xxs-12-wide_1pp19_11207",
  "col-ng-xs-auto": "_col-ng-xs-auto_1pp19_11235",
  "col-ng-xs-1": "_col-ng-xs-1_1pp19_11247",
  "col-ng-xs-2": "_col-ng-xs-2_1pp19_11257",
  "col-ng-xs-3": "_col-ng-xs-3_1pp19_11267",
  "col-ng-xs-4": "_col-ng-xs-4_1pp19_11277",
  "col-ng-xs-5": "_col-ng-xs-5_1pp19_11287",
  "col-ng-xs-6": "_col-ng-xs-6_1pp19_11297",
  "col-ng-xs-7": "_col-ng-xs-7_1pp19_11307",
  "col-ng-xs-8": "_col-ng-xs-8_1pp19_11317",
  "col-ng-xs-9": "_col-ng-xs-9_1pp19_11327",
  "col-ng-xs-10": "_col-ng-xs-10_1pp19_11337",
  "col-ng-xs-11": "_col-ng-xs-11_1pp19_11347",
  "col-ng-xs-12": "_col-ng-xs-12_1pp19_11357",
  "col-ng-xs-1-wide": "_col-ng-xs-1-wide_1pp19_11367",
  "col-ng-xs-2-wide": "_col-ng-xs-2-wide_1pp19_11395",
  "col-ng-xs-3-wide": "_col-ng-xs-3-wide_1pp19_11423",
  "col-ng-xs-4-wide": "_col-ng-xs-4-wide_1pp19_11451",
  "col-ng-xs-5-wide": "_col-ng-xs-5-wide_1pp19_11479",
  "col-ng-xs-6-wide": "_col-ng-xs-6-wide_1pp19_11507",
  "col-ng-xs-7-wide": "_col-ng-xs-7-wide_1pp19_11535",
  "col-ng-xs-8-wide": "_col-ng-xs-8-wide_1pp19_11563",
  "col-ng-xs-9-wide": "_col-ng-xs-9-wide_1pp19_11591",
  "col-ng-xs-10-wide": "_col-ng-xs-10-wide_1pp19_11619",
  "col-ng-xs-11-wide": "_col-ng-xs-11-wide_1pp19_11647",
  "col-ng-xs-12-wide": "_col-ng-xs-12-wide_1pp19_11675",
  "col-ng-s-auto": "_col-ng-s-auto_1pp19_11703",
  "col-ng-s-1": "_col-ng-s-1_1pp19_11715",
  "col-ng-s-2": "_col-ng-s-2_1pp19_11725",
  "col-ng-s-3": "_col-ng-s-3_1pp19_11735",
  "col-ng-s-4": "_col-ng-s-4_1pp19_11745",
  "col-ng-s-5": "_col-ng-s-5_1pp19_11755",
  "col-ng-s-6": "_col-ng-s-6_1pp19_11765",
  "col-ng-s-7": "_col-ng-s-7_1pp19_11775",
  "col-ng-s-8": "_col-ng-s-8_1pp19_11785",
  "col-ng-s-9": "_col-ng-s-9_1pp19_11795",
  "col-ng-s-10": "_col-ng-s-10_1pp19_11805",
  "col-ng-s-11": "_col-ng-s-11_1pp19_11815",
  "col-ng-s-12": "_col-ng-s-12_1pp19_11825",
  "col-ng-s-1-wide": "_col-ng-s-1-wide_1pp19_11835",
  "col-ng-s-2-wide": "_col-ng-s-2-wide_1pp19_11863",
  "col-ng-s-3-wide": "_col-ng-s-3-wide_1pp19_11891",
  "col-ng-s-4-wide": "_col-ng-s-4-wide_1pp19_11919",
  "col-ng-s-5-wide": "_col-ng-s-5-wide_1pp19_11947",
  "col-ng-s-6-wide": "_col-ng-s-6-wide_1pp19_11975",
  "col-ng-s-7-wide": "_col-ng-s-7-wide_1pp19_12003",
  "col-ng-s-8-wide": "_col-ng-s-8-wide_1pp19_12031",
  "col-ng-s-9-wide": "_col-ng-s-9-wide_1pp19_12059",
  "col-ng-s-10-wide": "_col-ng-s-10-wide_1pp19_12087",
  "col-ng-s-11-wide": "_col-ng-s-11-wide_1pp19_12115",
  "col-ng-s-12-wide": "_col-ng-s-12-wide_1pp19_12143",
  "col-ng-ssm-auto": "_col-ng-ssm-auto_1pp19_12171",
  "col-ng-ssm-1": "_col-ng-ssm-1_1pp19_12183",
  "col-ng-ssm-2": "_col-ng-ssm-2_1pp19_12193",
  "col-ng-ssm-3": "_col-ng-ssm-3_1pp19_12203",
  "col-ng-ssm-4": "_col-ng-ssm-4_1pp19_12213",
  "col-ng-ssm-5": "_col-ng-ssm-5_1pp19_12223",
  "col-ng-ssm-6": "_col-ng-ssm-6_1pp19_12233",
  "col-ng-ssm-7": "_col-ng-ssm-7_1pp19_12243",
  "col-ng-ssm-8": "_col-ng-ssm-8_1pp19_12253",
  "col-ng-ssm-9": "_col-ng-ssm-9_1pp19_12263",
  "col-ng-ssm-10": "_col-ng-ssm-10_1pp19_12273",
  "col-ng-ssm-11": "_col-ng-ssm-11_1pp19_12283",
  "col-ng-ssm-12": "_col-ng-ssm-12_1pp19_12293",
  "col-ng-ssm-1-wide": "_col-ng-ssm-1-wide_1pp19_12303",
  "col-ng-ssm-2-wide": "_col-ng-ssm-2-wide_1pp19_12331",
  "col-ng-ssm-3-wide": "_col-ng-ssm-3-wide_1pp19_12359",
  "col-ng-ssm-4-wide": "_col-ng-ssm-4-wide_1pp19_12387",
  "col-ng-ssm-5-wide": "_col-ng-ssm-5-wide_1pp19_12415",
  "col-ng-ssm-6-wide": "_col-ng-ssm-6-wide_1pp19_12443",
  "col-ng-ssm-7-wide": "_col-ng-ssm-7-wide_1pp19_12471",
  "col-ng-ssm-8-wide": "_col-ng-ssm-8-wide_1pp19_12499",
  "col-ng-ssm-9-wide": "_col-ng-ssm-9-wide_1pp19_12527",
  "col-ng-ssm-10-wide": "_col-ng-ssm-10-wide_1pp19_12555",
  "col-ng-ssm-11-wide": "_col-ng-ssm-11-wide_1pp19_12583",
  "col-ng-ssm-12-wide": "_col-ng-ssm-12-wide_1pp19_12611",
  "col-ng-sm-auto": "_col-ng-sm-auto_1pp19_12639",
  "col-ng-sm-1": "_col-ng-sm-1_1pp19_12651",
  "col-ng-sm-2": "_col-ng-sm-2_1pp19_12661",
  "col-ng-sm-3": "_col-ng-sm-3_1pp19_12671",
  "col-ng-sm-4": "_col-ng-sm-4_1pp19_12681",
  "col-ng-sm-5": "_col-ng-sm-5_1pp19_12691",
  "col-ng-sm-6": "_col-ng-sm-6_1pp19_12701",
  "col-ng-sm-7": "_col-ng-sm-7_1pp19_12711",
  "col-ng-sm-8": "_col-ng-sm-8_1pp19_12721",
  "col-ng-sm-9": "_col-ng-sm-9_1pp19_12731",
  "col-ng-sm-10": "_col-ng-sm-10_1pp19_12741",
  "col-ng-sm-11": "_col-ng-sm-11_1pp19_12751",
  "col-ng-sm-12": "_col-ng-sm-12_1pp19_12761",
  "col-ng-sm-1-wide": "_col-ng-sm-1-wide_1pp19_12771",
  "col-ng-sm-2-wide": "_col-ng-sm-2-wide_1pp19_12799",
  "col-ng-sm-3-wide": "_col-ng-sm-3-wide_1pp19_12827",
  "col-ng-sm-4-wide": "_col-ng-sm-4-wide_1pp19_12855",
  "col-ng-sm-5-wide": "_col-ng-sm-5-wide_1pp19_12883",
  "col-ng-sm-6-wide": "_col-ng-sm-6-wide_1pp19_12911",
  "col-ng-sm-7-wide": "_col-ng-sm-7-wide_1pp19_12939",
  "col-ng-sm-8-wide": "_col-ng-sm-8-wide_1pp19_12967",
  "col-ng-sm-9-wide": "_col-ng-sm-9-wide_1pp19_12995",
  "col-ng-sm-10-wide": "_col-ng-sm-10-wide_1pp19_13023",
  "col-ng-sm-11-wide": "_col-ng-sm-11-wide_1pp19_13051",
  "col-ng-sm-12-wide": "_col-ng-sm-12-wide_1pp19_13079",
  "col-ng-m-auto": "_col-ng-m-auto_1pp19_13107",
  "col-ng-m-1": "_col-ng-m-1_1pp19_13119",
  "col-ng-m-2": "_col-ng-m-2_1pp19_13129",
  "col-ng-m-3": "_col-ng-m-3_1pp19_13139",
  "col-ng-m-4": "_col-ng-m-4_1pp19_13149",
  "col-ng-m-5": "_col-ng-m-5_1pp19_13159",
  "col-ng-m-6": "_col-ng-m-6_1pp19_13169",
  "col-ng-m-7": "_col-ng-m-7_1pp19_13179",
  "col-ng-m-8": "_col-ng-m-8_1pp19_13189",
  "col-ng-m-9": "_col-ng-m-9_1pp19_13199",
  "col-ng-m-10": "_col-ng-m-10_1pp19_13209",
  "col-ng-m-11": "_col-ng-m-11_1pp19_13219",
  "col-ng-m-12": "_col-ng-m-12_1pp19_13229",
  "col-ng-m-1-wide": "_col-ng-m-1-wide_1pp19_13239",
  "col-ng-m-2-wide": "_col-ng-m-2-wide_1pp19_13267",
  "col-ng-m-3-wide": "_col-ng-m-3-wide_1pp19_13295",
  "col-ng-m-4-wide": "_col-ng-m-4-wide_1pp19_13323",
  "col-ng-m-5-wide": "_col-ng-m-5-wide_1pp19_13351",
  "col-ng-m-6-wide": "_col-ng-m-6-wide_1pp19_13379",
  "col-ng-m-7-wide": "_col-ng-m-7-wide_1pp19_13407",
  "col-ng-m-8-wide": "_col-ng-m-8-wide_1pp19_13435",
  "col-ng-m-9-wide": "_col-ng-m-9-wide_1pp19_13463",
  "col-ng-m-10-wide": "_col-ng-m-10-wide_1pp19_13491",
  "col-ng-m-11-wide": "_col-ng-m-11-wide_1pp19_13519",
  "col-ng-m-12-wide": "_col-ng-m-12-wide_1pp19_13547",
  "col-ng-xm-auto": "_col-ng-xm-auto_1pp19_13575",
  "col-ng-xm-1": "_col-ng-xm-1_1pp19_13587",
  "col-ng-xm-2": "_col-ng-xm-2_1pp19_13597",
  "col-ng-xm-3": "_col-ng-xm-3_1pp19_13607",
  "col-ng-xm-4": "_col-ng-xm-4_1pp19_13617",
  "col-ng-xm-5": "_col-ng-xm-5_1pp19_13627",
  "col-ng-xm-6": "_col-ng-xm-6_1pp19_13637",
  "col-ng-xm-7": "_col-ng-xm-7_1pp19_13647",
  "col-ng-xm-8": "_col-ng-xm-8_1pp19_13657",
  "col-ng-xm-9": "_col-ng-xm-9_1pp19_13667",
  "col-ng-xm-10": "_col-ng-xm-10_1pp19_13677",
  "col-ng-xm-11": "_col-ng-xm-11_1pp19_13687",
  "col-ng-xm-12": "_col-ng-xm-12_1pp19_13697",
  "col-ng-xm-1-wide": "_col-ng-xm-1-wide_1pp19_13707",
  "col-ng-xm-2-wide": "_col-ng-xm-2-wide_1pp19_13735",
  "col-ng-xm-3-wide": "_col-ng-xm-3-wide_1pp19_13763",
  "col-ng-xm-4-wide": "_col-ng-xm-4-wide_1pp19_13791",
  "col-ng-xm-5-wide": "_col-ng-xm-5-wide_1pp19_13819",
  "col-ng-xm-6-wide": "_col-ng-xm-6-wide_1pp19_13847",
  "col-ng-xm-7-wide": "_col-ng-xm-7-wide_1pp19_13875",
  "col-ng-xm-8-wide": "_col-ng-xm-8-wide_1pp19_13903",
  "col-ng-xm-9-wide": "_col-ng-xm-9-wide_1pp19_13931",
  "col-ng-xm-10-wide": "_col-ng-xm-10-wide_1pp19_13959",
  "col-ng-xm-11-wide": "_col-ng-xm-11-wide_1pp19_13987",
  "col-ng-xm-12-wide": "_col-ng-xm-12-wide_1pp19_14015",
  "col-ng-l-auto": "_col-ng-l-auto_1pp19_14043",
  "col-ng-l-1": "_col-ng-l-1_1pp19_14055",
  "col-ng-l-2": "_col-ng-l-2_1pp19_14065",
  "col-ng-l-3": "_col-ng-l-3_1pp19_14075",
  "col-ng-l-4": "_col-ng-l-4_1pp19_14085",
  "col-ng-l-5": "_col-ng-l-5_1pp19_14095",
  "col-ng-l-6": "_col-ng-l-6_1pp19_14105",
  "col-ng-l-7": "_col-ng-l-7_1pp19_14115",
  "col-ng-l-8": "_col-ng-l-8_1pp19_14125",
  "col-ng-l-9": "_col-ng-l-9_1pp19_14135",
  "col-ng-l-10": "_col-ng-l-10_1pp19_14145",
  "col-ng-l-11": "_col-ng-l-11_1pp19_14155",
  "col-ng-l-12": "_col-ng-l-12_1pp19_14165",
  "col-ng-l-1-wide": "_col-ng-l-1-wide_1pp19_14175",
  "col-ng-l-2-wide": "_col-ng-l-2-wide_1pp19_14203",
  "col-ng-l-3-wide": "_col-ng-l-3-wide_1pp19_14231",
  "col-ng-l-4-wide": "_col-ng-l-4-wide_1pp19_14259",
  "col-ng-l-5-wide": "_col-ng-l-5-wide_1pp19_14287",
  "col-ng-l-6-wide": "_col-ng-l-6-wide_1pp19_14315",
  "col-ng-l-7-wide": "_col-ng-l-7-wide_1pp19_14343",
  "col-ng-l-8-wide": "_col-ng-l-8-wide_1pp19_14371",
  "col-ng-l-9-wide": "_col-ng-l-9-wide_1pp19_14399",
  "col-ng-l-10-wide": "_col-ng-l-10-wide_1pp19_14427",
  "col-ng-l-11-wide": "_col-ng-l-11-wide_1pp19_14455",
  "col-ng-l-12-wide": "_col-ng-l-12-wide_1pp19_14483",
  "col-ng-xl-auto": "_col-ng-xl-auto_1pp19_14511",
  "col-ng-xl-1": "_col-ng-xl-1_1pp19_14523",
  "col-ng-xl-2": "_col-ng-xl-2_1pp19_14533",
  "col-ng-xl-3": "_col-ng-xl-3_1pp19_14543",
  "col-ng-xl-4": "_col-ng-xl-4_1pp19_14553",
  "col-ng-xl-5": "_col-ng-xl-5_1pp19_14563",
  "col-ng-xl-6": "_col-ng-xl-6_1pp19_14573",
  "col-ng-xl-7": "_col-ng-xl-7_1pp19_14583",
  "col-ng-xl-8": "_col-ng-xl-8_1pp19_14593",
  "col-ng-xl-9": "_col-ng-xl-9_1pp19_14603",
  "col-ng-xl-10": "_col-ng-xl-10_1pp19_14613",
  "col-ng-xl-11": "_col-ng-xl-11_1pp19_14623",
  "col-ng-xl-12": "_col-ng-xl-12_1pp19_14633",
  "col-ng-xl-1-wide": "_col-ng-xl-1-wide_1pp19_14643",
  "col-ng-xl-2-wide": "_col-ng-xl-2-wide_1pp19_14671",
  "col-ng-xl-3-wide": "_col-ng-xl-3-wide_1pp19_14699",
  "col-ng-xl-4-wide": "_col-ng-xl-4-wide_1pp19_14727",
  "col-ng-xl-5-wide": "_col-ng-xl-5-wide_1pp19_14755",
  "col-ng-xl-6-wide": "_col-ng-xl-6-wide_1pp19_14783",
  "col-ng-xl-7-wide": "_col-ng-xl-7-wide_1pp19_14811",
  "col-ng-xl-8-wide": "_col-ng-xl-8-wide_1pp19_14839",
  "col-ng-xl-9-wide": "_col-ng-xl-9-wide_1pp19_14867",
  "col-ng-xl-10-wide": "_col-ng-xl-10-wide_1pp19_14895",
  "col-ng-xl-11-wide": "_col-ng-xl-11-wide_1pp19_14923",
  "col-ng-xl-12-wide": "_col-ng-xl-12-wide_1pp19_14951",
  "col-ng-xxl-auto": "_col-ng-xxl-auto_1pp19_14979",
  "col-ng-xxl-1": "_col-ng-xxl-1_1pp19_14991",
  "col-ng-xxl-2": "_col-ng-xxl-2_1pp19_15001",
  "col-ng-xxl-3": "_col-ng-xxl-3_1pp19_15011",
  "col-ng-xxl-4": "_col-ng-xxl-4_1pp19_15021",
  "col-ng-xxl-5": "_col-ng-xxl-5_1pp19_15031",
  "col-ng-xxl-6": "_col-ng-xxl-6_1pp19_15041",
  "col-ng-xxl-7": "_col-ng-xxl-7_1pp19_15051",
  "col-ng-xxl-8": "_col-ng-xxl-8_1pp19_15061",
  "col-ng-xxl-9": "_col-ng-xxl-9_1pp19_15071",
  "col-ng-xxl-10": "_col-ng-xxl-10_1pp19_15081",
  "col-ng-xxl-11": "_col-ng-xxl-11_1pp19_15091",
  "col-ng-xxl-12": "_col-ng-xxl-12_1pp19_15101",
  "col-ng-xxl-1-wide": "_col-ng-xxl-1-wide_1pp19_15111",
  "col-ng-xxl-2-wide": "_col-ng-xxl-2-wide_1pp19_15139",
  "col-ng-xxl-3-wide": "_col-ng-xxl-3-wide_1pp19_15167",
  "col-ng-xxl-4-wide": "_col-ng-xxl-4-wide_1pp19_15195",
  "col-ng-xxl-5-wide": "_col-ng-xxl-5-wide_1pp19_15223",
  "col-ng-xxl-6-wide": "_col-ng-xxl-6-wide_1pp19_15251",
  "col-ng-xxl-7-wide": "_col-ng-xxl-7-wide_1pp19_15279",
  "col-ng-xxl-8-wide": "_col-ng-xxl-8-wide_1pp19_15307",
  "col-ng-xxl-9-wide": "_col-ng-xxl-9-wide_1pp19_15335",
  "col-ng-xxl-10-wide": "_col-ng-xxl-10-wide_1pp19_15363",
  "col-ng-xxl-11-wide": "_col-ng-xxl-11-wide_1pp19_15391",
  "col-ng-xxl-12-wide": "_col-ng-xxl-12-wide_1pp19_15419",
  "offset-xxs-0": "_offset-xxs-0_1pp19_15449",
  "offset-xxs-1": "_offset-xxs-1_1pp19_15452",
  "offset-xxs-2": "_offset-xxs-2_1pp19_15455",
  "offset-xxs-3": "_offset-xxs-3_1pp19_15458",
  "offset-xxs-4": "_offset-xxs-4_1pp19_15461",
  "offset-xxs-5": "_offset-xxs-5_1pp19_15464",
  "offset-xxs-6": "_offset-xxs-6_1pp19_15467",
  "offset-xxs-7": "_offset-xxs-7_1pp19_15470",
  "offset-xxs-8": "_offset-xxs-8_1pp19_15473",
  "offset-xxs-9": "_offset-xxs-9_1pp19_15476",
  "offset-xxs-10": "_offset-xxs-10_1pp19_15479",
  "offset-xxs-11": "_offset-xxs-11_1pp19_15482",
  "offset-xs-0": "_offset-xs-0_1pp19_15487",
  "offset-xs-1": "_offset-xs-1_1pp19_15490",
  "offset-xs-2": "_offset-xs-2_1pp19_15493",
  "offset-xs-3": "_offset-xs-3_1pp19_15496",
  "offset-xs-4": "_offset-xs-4_1pp19_15499",
  "offset-xs-5": "_offset-xs-5_1pp19_15502",
  "offset-xs-6": "_offset-xs-6_1pp19_15505",
  "offset-xs-7": "_offset-xs-7_1pp19_15508",
  "offset-xs-8": "_offset-xs-8_1pp19_15511",
  "offset-xs-9": "_offset-xs-9_1pp19_15514",
  "offset-xs-10": "_offset-xs-10_1pp19_15517",
  "offset-xs-11": "_offset-xs-11_1pp19_15520",
  "offset-s-0": "_offset-s-0_1pp19_15525",
  "offset-s-1": "_offset-s-1_1pp19_15528",
  "offset-s-2": "_offset-s-2_1pp19_15531",
  "offset-s-3": "_offset-s-3_1pp19_15534",
  "offset-s-4": "_offset-s-4_1pp19_15537",
  "offset-s-5": "_offset-s-5_1pp19_15540",
  "offset-s-6": "_offset-s-6_1pp19_15543",
  "offset-s-7": "_offset-s-7_1pp19_15546",
  "offset-s-8": "_offset-s-8_1pp19_15549",
  "offset-s-9": "_offset-s-9_1pp19_15552",
  "offset-s-10": "_offset-s-10_1pp19_15555",
  "offset-s-11": "_offset-s-11_1pp19_15558",
  "offset-ssm-0": "_offset-ssm-0_1pp19_15563",
  "offset-ssm-1": "_offset-ssm-1_1pp19_15566",
  "offset-ssm-2": "_offset-ssm-2_1pp19_15569",
  "offset-ssm-3": "_offset-ssm-3_1pp19_15572",
  "offset-ssm-4": "_offset-ssm-4_1pp19_15575",
  "offset-ssm-5": "_offset-ssm-5_1pp19_15578",
  "offset-ssm-6": "_offset-ssm-6_1pp19_15581",
  "offset-ssm-7": "_offset-ssm-7_1pp19_15584",
  "offset-ssm-8": "_offset-ssm-8_1pp19_15587",
  "offset-ssm-9": "_offset-ssm-9_1pp19_15590",
  "offset-ssm-10": "_offset-ssm-10_1pp19_15593",
  "offset-ssm-11": "_offset-ssm-11_1pp19_15596",
  "offset-sm-0": "_offset-sm-0_1pp19_15601",
  "offset-sm-1": "_offset-sm-1_1pp19_15604",
  "offset-sm-2": "_offset-sm-2_1pp19_15607",
  "offset-sm-3": "_offset-sm-3_1pp19_15610",
  "offset-sm-4": "_offset-sm-4_1pp19_15613",
  "offset-sm-5": "_offset-sm-5_1pp19_15616",
  "offset-sm-6": "_offset-sm-6_1pp19_15619",
  "offset-sm-7": "_offset-sm-7_1pp19_15622",
  "offset-sm-8": "_offset-sm-8_1pp19_15625",
  "offset-sm-9": "_offset-sm-9_1pp19_15628",
  "offset-sm-10": "_offset-sm-10_1pp19_15631",
  "offset-sm-11": "_offset-sm-11_1pp19_15634",
  "offset-m-0": "_offset-m-0_1pp19_15639",
  "offset-m-1": "_offset-m-1_1pp19_15642",
  "offset-m-2": "_offset-m-2_1pp19_15645",
  "offset-m-3": "_offset-m-3_1pp19_15648",
  "offset-m-4": "_offset-m-4_1pp19_15651",
  "offset-m-5": "_offset-m-5_1pp19_15654",
  "offset-m-6": "_offset-m-6_1pp19_15657",
  "offset-m-7": "_offset-m-7_1pp19_15660",
  "offset-m-8": "_offset-m-8_1pp19_15663",
  "offset-m-9": "_offset-m-9_1pp19_15666",
  "offset-m-10": "_offset-m-10_1pp19_15669",
  "offset-m-11": "_offset-m-11_1pp19_15672",
  "offset-xm-0": "_offset-xm-0_1pp19_15677",
  "offset-xm-1": "_offset-xm-1_1pp19_15680",
  "offset-xm-2": "_offset-xm-2_1pp19_15683",
  "offset-xm-3": "_offset-xm-3_1pp19_15686",
  "offset-xm-4": "_offset-xm-4_1pp19_15689",
  "offset-xm-5": "_offset-xm-5_1pp19_15692",
  "offset-xm-6": "_offset-xm-6_1pp19_15695",
  "offset-xm-7": "_offset-xm-7_1pp19_15698",
  "offset-xm-8": "_offset-xm-8_1pp19_15701",
  "offset-xm-9": "_offset-xm-9_1pp19_15704",
  "offset-xm-10": "_offset-xm-10_1pp19_15707",
  "offset-xm-11": "_offset-xm-11_1pp19_15710",
  "offset-l-0": "_offset-l-0_1pp19_15715",
  "offset-l-1": "_offset-l-1_1pp19_15718",
  "offset-l-2": "_offset-l-2_1pp19_15721",
  "offset-l-3": "_offset-l-3_1pp19_15724",
  "offset-l-4": "_offset-l-4_1pp19_15727",
  "offset-l-5": "_offset-l-5_1pp19_15730",
  "offset-l-6": "_offset-l-6_1pp19_15733",
  "offset-l-7": "_offset-l-7_1pp19_15736",
  "offset-l-8": "_offset-l-8_1pp19_15739",
  "offset-l-9": "_offset-l-9_1pp19_15742",
  "offset-l-10": "_offset-l-10_1pp19_15745",
  "offset-l-11": "_offset-l-11_1pp19_15748",
  "offset-xl-0": "_offset-xl-0_1pp19_15753",
  "offset-xl-1": "_offset-xl-1_1pp19_15756",
  "offset-xl-2": "_offset-xl-2_1pp19_15759",
  "offset-xl-3": "_offset-xl-3_1pp19_15762",
  "offset-xl-4": "_offset-xl-4_1pp19_15765",
  "offset-xl-5": "_offset-xl-5_1pp19_15768",
  "offset-xl-6": "_offset-xl-6_1pp19_15771",
  "offset-xl-7": "_offset-xl-7_1pp19_15774",
  "offset-xl-8": "_offset-xl-8_1pp19_15777",
  "offset-xl-9": "_offset-xl-9_1pp19_15780",
  "offset-xl-10": "_offset-xl-10_1pp19_15783",
  "offset-xl-11": "_offset-xl-11_1pp19_15786",
  "offset-xxl-0": "_offset-xxl-0_1pp19_15791",
  "offset-xxl-1": "_offset-xxl-1_1pp19_15794",
  "offset-xxl-2": "_offset-xxl-2_1pp19_15797",
  "offset-xxl-3": "_offset-xxl-3_1pp19_15800",
  "offset-xxl-4": "_offset-xxl-4_1pp19_15803",
  "offset-xxl-5": "_offset-xxl-5_1pp19_15806",
  "offset-xxl-6": "_offset-xxl-6_1pp19_15809",
  "offset-xxl-7": "_offset-xxl-7_1pp19_15812",
  "offset-xxl-8": "_offset-xxl-8_1pp19_15815",
  "offset-xxl-9": "_offset-xxl-9_1pp19_15818",
  "offset-xxl-10": "_offset-xxl-10_1pp19_15821",
  "offset-xxl-11": "_offset-xxl-11_1pp19_15824",
  "cg-xxs-all": "_cg-xxs-all_1pp19_15830",
  "cg-xxs-left": "_cg-xxs-left_1pp19_15834",
  "cg-xxs-right": "_cg-xxs-right_1pp19_15837",
  "cg-xxs-none": "_cg-xxs-none_1pp19_15840",
  "cg-xs-all": "_cg-xs-all_1pp19_15894",
  "cg-xs-left": "_cg-xs-left_1pp19_15898",
  "cg-xs-right": "_cg-xs-right_1pp19_15901",
  "cg-xs-none": "_cg-xs-none_1pp19_15904",
  "cg-s-all": "_cg-s-all_1pp19_15958",
  "cg-s-left": "_cg-s-left_1pp19_15962",
  "cg-s-right": "_cg-s-right_1pp19_15965",
  "cg-s-none": "_cg-s-none_1pp19_15968",
  "cg-ssm-all": "_cg-ssm-all_1pp19_16022",
  "cg-ssm-left": "_cg-ssm-left_1pp19_16026",
  "cg-ssm-right": "_cg-ssm-right_1pp19_16029",
  "cg-ssm-none": "_cg-ssm-none_1pp19_16032",
  "cg-sm-all": "_cg-sm-all_1pp19_16086",
  "cg-sm-left": "_cg-sm-left_1pp19_16090",
  "cg-sm-right": "_cg-sm-right_1pp19_16093",
  "cg-sm-none": "_cg-sm-none_1pp19_16096",
  "cg-m-all": "_cg-m-all_1pp19_16150",
  "cg-m-left": "_cg-m-left_1pp19_16154",
  "cg-m-right": "_cg-m-right_1pp19_16157",
  "cg-m-none": "_cg-m-none_1pp19_16160",
  "cg-xm-all": "_cg-xm-all_1pp19_16214",
  "cg-xm-left": "_cg-xm-left_1pp19_16218",
  "cg-xm-right": "_cg-xm-right_1pp19_16221",
  "cg-xm-none": "_cg-xm-none_1pp19_16224",
  "cg-l-all": "_cg-l-all_1pp19_16278",
  "cg-l-left": "_cg-l-left_1pp19_16282",
  "cg-l-right": "_cg-l-right_1pp19_16285",
  "cg-l-none": "_cg-l-none_1pp19_16288",
  "cg-xl-all": "_cg-xl-all_1pp19_16342",
  "cg-xl-left": "_cg-xl-left_1pp19_16346",
  "cg-xl-right": "_cg-xl-right_1pp19_16349",
  "cg-xl-none": "_cg-xl-none_1pp19_16352",
  "cg-xxl-all": "_cg-xxl-all_1pp19_16406",
  "cg-xxl-left": "_cg-xxl-left_1pp19_16410",
  "cg-xxl-right": "_cg-xxl-right_1pp19_16413",
  "cg-xxl-none": "_cg-xxl-none_1pp19_16416",
  article: N,
  "slide-in-out": "_slide-in-out_1pp19_1",
  "fade-in-out": "_fade-in-out_1pp19_1"
}, C = (_) => typeof _ == "object" ? _.wide ? `${_.value}-wide` : `${_.value}` : `${_}`, S = h((_, c) => {
  const {
    noGutter: s,
    collapseGutter: x,
    span: e = "auto",
    offset: g = "auto",
    isArticle: n = !1,
    className: m,
    children: i,
    ...f
  } = _, d = p(s ? "col-ng" : "col", e, "auto", {
    specValueMapper: C
  }), w = p("offset", g, "auto"), t = p("cg", x, ""), a = n ? ["article"] : [""], u = y(
    l(d, o),
    l(w, o),
    l(t, o),
    l(a, o),
    m
  );
  return /* @__PURE__ */ r("div", { ref: c, className: u, ...f, children: i });
});
S.displayName = "Col";
export {
  S as Col
};
